// export default [

// ]
import type { RouteRecordRaw } from 'vue-router'

export const TaskRoutes: RouteRecordRaw[] = [
  {
    path: '/Task',
    name: 'Task',
    redirect: { name: 'dashboard' },
    meta: {
      title: 'routes.Task',
      requiresAuth: true,
      breadcrumb: 'Task'
    },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/modules/TaskManagement/dashboard/taskDashboard.vue'),
        meta: {
          title: 'routes.dashboard',
          requiresAuth: true,
          breadcrumb: 'Dashboard'
        }
      },
      {
        path: 'tasks',
        name: 'taskList',
        component: () => import('@/modules/TaskManagement/transaction/components/TaskList.vue'),
        meta: {
          title: 'Task List',
          requiresAuth: true,
          permission: 'taskManagement.tasks.view',
          breadcrumb: 'Task List'
        }
      },
      {
        path: 'tasksDetail',
        name: 'tasksDetail',
        component: () => import('@/modules/TaskManagement/transaction/components/TaskDetails.vue'),
        meta: {
          title: 'Task Details',
          requiresAuth: true,
          permission: 'taskManagement.tasks.view',
          breadcrumb: 'Task Details'
        }
      },
      {
        path: 'task-creation',
        name: 'taskCreation',
        component: () => import('@/modules/TaskManagement/transaction/components/TaskCreateEdit.vue'),
        meta: {
          title: 'New Task Creation',
          requiresAuth: true,
          permission: 'taskManagement.tasks.create',
          breadcrumb: 'New Task Creation'
        }
      },
      {
        path: 'task-creation/:id',
        name: 'taskCreationEdit',
        component: () => import('@/modules/TaskManagement/transaction/components/TaskCreateEdit.vue'),
        props: true,
        meta: {
          title: 'Edit Task',
          requiresAuth: true,
          permission: 'taskManagement.tasks.edit',
          breadcrumb: 'Edit Task'
        }
      },
      {
        path: 'escalations',
        name: 'escalationDashboard',
        component: () => import('@/modules/TaskManagement/transaction/components/EscalationDashboard.vue'),
        meta: {
          title: 'Escalation Dashboard',
          requiresAuth: true,
          permission: 'taskManagement.escalations.view',
          breadcrumb: 'Escalation Dashboard'
        }
      },
      {
        path: 'taskType',
        name: 'taskType',
        component: () => import('@/modules/TaskManagement/masters/taskType/components/TaskTypeList.vue'),
        meta: {
          title: 'routes.taskType',
          requiresAuth: true,
          breadcrumb: 'Task Type Master'
        }
      },
      {
        path: 'taskStatus',
        name: 'taskStatus',
        component: () => import('@/modules/TaskManagement/masters/taskStatus/components/TaskStatusList.vue'),
        meta: {
          title: 'routes.taskStatus',
          requiresAuth: true,
          breadcrumb: 'Task Status Master'
        }
      },
      {
        path: 'taskPriority',
        name: 'taskPriority',
        component: () => import('@/modules/TaskManagement/masters/taskPriority/components/TaskPriorityList.vue'),
        meta: {
          title: 'routes.taskPriority',
          requiresAuth: true,
          breadcrumb: 'Task Priority Master'
        }
      },
      {
        path: 'slaConfig',
        name: 'slaConfig',
        component: () => import('@/modules/TaskManagement/masters/slaConfig/components/SLAConfigList.vue'),
        meta: {
          title: 'routes.slaConfig',
          requiresAuth: true,
          breadcrumb: 'SLA Configuration Master'
        }
      },
      {
        path: 'assignmentType',
        name: 'assignmentType',
        component: () => import('@/modules/TaskManagement/masters/assignmentType/components/AssignmentTypeList.vue'),
        meta: {
          title: 'routes.assignmentType',
          requiresAuth: true,
          breadcrumb: 'Assignment Type Master'
        }
      },
      {
        path: 'serviceType',
        name: 'serviceType',
        component: () => import('@/modules/TaskManagement/masters/serviceType/components/ServiceTypeList.vue'),
        meta: {
          title: 'routes.serviceType',
          requiresAuth: true,
          breadcrumb: 'Service Type Master'
        }
      },
      {
        path: 'serviceSubType',
        name: 'serviceSubType',
        component: () => import('@/modules/TaskManagement/masters/serviceSubType/components/ServiceSubTypeList.vue'),
        meta: {
          title: 'routes.serviceSubType',
          requiresAuth: true,
          breadcrumb: 'Service Sub Type Master'
        }
      },
      {
        path: 'codeTemplate',
        name: 'codeTemplate',
        component: () => import('@/modules/TaskManagement/codeTemplate/components/CodeTempate.vue'),
        meta: {
          title: 'Code Template',
          requiresAuth: true,
          breadcrumb: 'Code Template Master'
        }
      },
      {
        path: 'bulk-assign',
        name: 'bulkAssign',
        component: () => import('@/modules/TaskManagement/transaction/components/BulkAssign.vue'),
        meta: {
          title: 'Bulk Assign Tasks',
          requiresAuth: true,
          permission: 'taskManagement.tasks.edit',
          breadcrumb: 'Bulk Assign Tasks'
        }
      },
      {
        path: 'reports',
        name: 'taskReports',
        component: () => import('@/modules/TaskManagement/reports/reports.vue'),
        meta: {
          title: 'Task Reports',
          requiresAuth: true,
          permission: 'taskManagement.reports.view',
          breadcrumb: 'Task Reports'
        }
      }

    ]
  }
]
